class SubcollectionCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        // slidesPerView: 2.2,
        slidesPerView: "auto",
        // spaceBetween: 10,
        navigation: {
          nextEl: this.querySelector("[data-subcollection-navigation-next]"),
          prevEl: this.querySelector(
            "[data-subcollection-navigation-previous]",
          ),
        },
        // breakpoints: {
        //   768: {
        //     slidesPerView: 3,
        //   },
        //   1024: {
        //     slidesPerView: 4,
        //   },
        //   1440: {
        //     slidesPerView: 5,
        //   }
        // },
        on: {
          lock: () => {
            this.classList.add(
              "subcollections__subcollection-carousel-wrapper--locked",
            );
          },
          unlock: () => {
            this.classList.remove(
              "subcollections__subcollection-carousel-wrapper--locked",
            );
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("subcollection-carousel")) {
  customElements.define("subcollection-carousel", SubcollectionCarousel);
}
